module.exports = __webpack_public_path__ + "img/tic-tok-icon.d25bc5e.png";